import React, { lazy } from 'react';

import { createBrowserRouter } from 'react-router-dom';

import UserAuthChecker from '../HOC/auth';
import Root from '../Root';

const CompareDraft = lazy(() => import('../Pages/Drafts/CompareDraft'));
const CompareLayout = lazy(() => import('../components/layout/CompareLayout'));
const ContractComponent = lazy(
  () => import('../Pages/Contracts/ContractComponent')
);
const DataGrid = lazy(() => import('../components/dataGrid/DataGrid'));
const DraftLayout = lazy(() => import('../components/layout/DraftLayout'));
const Drafts = lazy(() => import('../Pages/Drafts'));
const ViewDraft = lazy(() => import('../Pages/Drafts/ViewDraft'));

export const privateRouter = createBrowserRouter([
  {
    path: '*',
    Component: UserAuthChecker(Root),
    children: [
      {
        path: 'dictionary',
        element: <ContractComponent />,
      },
      { path: 'dictionary/:id', element: <DataGrid /> },
      { path: 'drafts', element: <Drafts /> },
      {
        path: 'drafts',
        element: <DraftLayout />,
        children: [{ path: 'view-draft/:id', element: <ViewDraft /> }],
      },
      {
        path: 'compare',
        element: <CompareLayout />,
        children: [
          {
            path: 'drafts/:id',
            element: <CompareDraft />,
          },
        ],
      },
    ],
  },
]);
